import { LocationType } from '@game/enums';
import type { ClientArea, ClientAreaLocation, ClientLocation, Roles } from '@game/shared-types';

import type { MenuData } from '../types/menu.types';

export interface UserState {
  location: ClientLocation;
  locationsMenu: MenuData[];
  area: ClientArea;
  roles: Roles;
  mutedReason: string;
  mutedUntil: number;
  muteRemovedEarly: boolean;
  reconnectAttempt: number;
  serverMidnight: number;
  nextServerMidnight: number;
  twitchStreamStatus: boolean;
  discordAccount: string;
  twitchAccount: string;
  hasAPIKey: boolean;
  mustChangeName: boolean;
}

export const defaultLocation: ClientLocation = {
  name: 'Unknown',
  type: LocationType.Stats,
  menuText: 'Unknown',
  slug: 'unknown',
  description: 'Unknown.',
  imageUrl: 'https://example.com/example.webp',
  title: 'Unknown',
  missionBoard: [],
};

const defaultAreaLocation: ClientAreaLocation = {
  name: 'Unknown',
  menuText: 'Unknown',
  imageUrl: 'https://example.com/example.webp',
  slug: 'unknown',
  title: 'Unknown',
  type: 1,
  missions: [],
};

const defaultArea: ClientArea = {
  name: 'Unknown',
  defaultHospital: defaultAreaLocation,
  locations: [],
  locationNames: [],
  soundtracks: [{ title: 'Unknown', urls: 'unknown.webm, unknown.mp3, unknown.m4a' }],
  defeatedTips: [],
};

export const userDefault: UserState = {
  location: defaultLocation,
  locationsMenu: [
    {
      key: '',
      path: '',
      destination: '',
      missions: [],
      imageUrl: '',
      content: '',
      type: LocationType.Unknown,
    },
  ],
  area: defaultArea,
  roles: [],
  mutedReason: '',
  mutedUntil: 0,
  muteRemovedEarly: false,
  reconnectAttempt: 0,
  serverMidnight: 0,
  nextServerMidnight: 0,
  twitchStreamStatus: false,
  discordAccount: '',
  twitchAccount: '',
  hasAPIKey: false,
  mustChangeName: false,
};
